const Config = {
	//serverUrl: 'http://server.werktopkantoor.on-d-mand'
	//serverUrl: 'https://test-server.werktopkantoor.nl',
	//serverUrl: 'https://server.werktopkantoor.nl',
	serverUrl: 'https://server-42.werktopkantoor.nl',
	serverUrlV2: 'https://{{customer}}.server.werktopkantoor.nl',
}

export default Config;
